<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "category",
  data() {
    return {};
  },
};
</script>
